const stripTags = (html: string): string => html.replace(/<[^>]+>/g, "").trim();

export interface SplitQuestionTitle {
  eyebrow: string | null;
  title: string;
}

/**
 * Backend authors question titleHtml as `<p><b>{eyebrow}</b>{question}</p>`
 * (3.0.3): the bold span is the grey eyebrow line, the rest is the serif
 * question. Questions without a `<b>` (e.g. company questions) have no
 * eyebrow — the full text is the title. Mirrors mobile's split in
 * AssessmentQuestionUplift.tsx.
 */
export const splitQuestionTitle = (
  titleHtml: string | null | undefined
): SplitQuestionTitle => {
  if (!titleHtml) {
    return { eyebrow: null, title: "" };
  }

  const match = titleHtml.match(/<b>([\s\S]*?)<\/b>([\s\S]*)/i);
  if (!match) {
    return { eyebrow: null, title: stripTags(titleHtml) };
  }

  return {
    eyebrow: stripTags(match[1]),
    title: stripTags(match[2]),
  };
};
